import { ReactComponent as dashboardIcon } from "../images/menuListIcons/dashboard-icon.svg";
import { ReactComponent as bredbookIcon } from "../images/menuListIcons/bredbook-icon.svg";
import { ReactComponent as fileIcon } from "../images/menuListIcons/file-icon.svg";
import { ReactComponent as instructionIcon } from "../images/menuListIcons/instruction-icon.svg";
import { ReactComponent as newsIcon } from "../images/menuListIcons/news-icon.svg";
import { ReactComponent as settingsIcon } from "../images/menuListIcons/settings-icon.svg";
import { ReactComponent as usersIcon } from "../images/menuListIcons/users-icon.svg";

export const menuList = [
    {
        id: 1,
        name: "Дашборд",
        link: "/dashboard",
        links: [],
        img: dashboardIcon,
    },
    {
        id: 2,
        name: "Брендбук",
        link: "/brandbook",
        links: [],
        img: bredbookIcon,
    },
    {
        id: 3,
        name: "Файли",
        link: "/files",
        links: [],
        img: fileIcon,
    },
    {
        id: 4,
        name: "Інструкція по використанню",
        link: "/instruction",
        links: [],
        img: instructionIcon,
    },
    {
        id: 5,
        name: "Новини змін",
        link: "/news",
        links: [],
        img: newsIcon,
    },
    {
        id: 6,
        name: "Користувачі",
        link: "/",
        links: [
            { id: 1, name: "test1", link: "/test1" },
            { id: 2, name: "Test2", link: "/test2" },
        ],
        img: usersIcon,
    },
    {
        id: 7,
        name: "Налаштування",
        link: "/",
        links: [
            { id: 1, name: "Елементи оформлення", link: "/elements" },
            { id: 2, name: "Відділи", link: "/sections" },
            { id: 2, name: "Обладнання", link: "/equipment" },
        ],
        img: settingsIcon,
    },
];

export const menuListNames = [
    {
        name: "Дашборд",
        link: "/dashboard",
    },
    {
        name: "Брендбук",
        link: "/brandbook",
    },
    {
        name: "Файли",
        link: "/files",
    },
    {
        name: "Інструкція по використанню",
        link: "/instruction",
    },
    {
        name: "Новини змін",
        link: "/news",
    },
    {
        name: "test1",
        link: "/test1",
    },
    {
        name: "Test2",
        link: "/test2",
    },
    {
        name: "Елементи оформлення",
        link: "/elements",
    },
    {
        name: "Відділи",
        link: "/sections",
    },
    {
        name: "Обладнання",
        link: "/equipment",
    },
    {
        name: "Файли",
        link: "/files/create",
    },
];
